<script>
    import Library from '../../Models/LibraryORM';
    import Loader from '../Loader.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from '../Confirmation.svelte';
    import SortableTable from '../SortableTable.svelte';

    import {db} from "../../Database.svelte";

    import {session, isAdmin} from '../../Utilities/Session.svelte';
    import {addModal} from '../ModalManager.svelte';
    import ImportModal from './ImportModal.svelte';
    import parseCSV from '../../lib/csv';
    import parseFields from '../../Utilities/parseFields';
    import {sortBy, groupBy} from 'lodash-es';

    import AssessmentTypeModel from '../../Models/assessmentTypeModel';
    import QuestionLibrary from '../../Models/QuestionLibraryModel';
    import LibraryTags from '../../Models/LibraryTagModel';

    import QuestionTypes from '../../lib/QuestionTypes';

    import { generateCSV } from '../../lib/csv';
    import { downloadFile } from '../../Utilities/util';


    let assessment_types = AssessmentTypeModel.getAssessmentTypeList();
    let assessment_type_mappings;

    let question_libraries = QuestionLibrary.getList();
    let library_tags = LibraryTags.getList();

    export let params;

    let sortFields, formFields;

    let moderation_items = new Set();

    function load_moderation_items(lib) {
        moderation_items = new Set();

        for (let item of lib.moderation_queue) {
            moderation_items.add(item.details.template_id);
        }
    }

    function loadLibrary(library_store) {
        if (!library_store) return;

        let fieldData = parseFields(library_store.fields);

        formFields = fieldData.formFields;
        sortFields = fieldData.sortFields;

        load_moderation_items(library_store);

        sortFields[0].formatter = (value, row) => {
            if (moderation_items.has(row.details._id)) {
                return `🗟 ${value}`
            }
            return value;
        }
    }

    function addItem() {
        addFormModal({
            fields: formFields
        }).then(formData => {
            formData.submitter = $session.user.email;

            library.moderation_queue.newItem(formData).then(() => {
                notifier.success("Item Added to Moderation Queue")
            })
        }).catch(console.error)
    }

    function editItem(field) {
        let data = JSON.parse(JSON.stringify(field.details));
        addFormModal({
            fields: formFields,
            data
        }).then((data) => {
            addFormModal({
                fields: [{
                    name: "comment",
                    label: "Change Comment",
                    type: "textarea",
                    required: true
                }]
            }).then((formData) => {
                let cloned = JSON.parse(JSON.stringify(data));

                cloned.template_id = cloned._id;

                delete cloned._id;
                delete cloned._rev;

                library.moderation_queue.newItem({
                    ...cloned,
                    submitter: $session.user.email,
                    changeComment: formData.comment
                }).then(() => {
                    notifier.success("Item Added to Moderation Queue");
                })
            })
        }).catch(() => {});
    }

    function exportItems(){
        console.log(sortFields, formFields)
        let header_fields = ["_id", ...formFields.map(f => f.name)];
        let field_defs = Object.fromEntries(sortFields.map(f => [f.field, f]));

        const s = sortFields.map(s => [s.field, s]);
        console.log(s);

        let data = [...$library_store.items].map(ref => header_fields.map(field => {
            console.log(field, typeof ref.details[field])
            if (typeof ref.details[field] == "string") {
                return ref.details[field];
            } else if (!ref.details[field]) {
                return "";
            } else {
                console.log(field, field_defs[field])
                if (field_defs[field].type == "customTags") {
                    return JSON.stringify(ref.details[field].map(t => t.name)).slice(1, -1);
                } else if (field_defs[field].type == "referenceLibrary") {
                    return JSON.stringify(ref.details[field].map(t => {return {framework: t.framework, control: t.name}}))
                } else {
                    return JSON.stringify(ref.details[field]);
                }
            }
        }))

        let csv = generateCSV(header_fields, data);

        downloadFile(csv, `${$library_store.details.name}_export.csv`, "text/csv");
    }

    function deleteItem(field) {
        confirm(`Are you sure you want to remove "${field.details.name}"?`).then(() => {
            field.delete().then(() => {
                notifier.success("Item Removed")
            })
        }).catch(() => {})
    }

    function importItems() {
        let headers = formFields.map(f => f.name);
        addModal(ImportModal, {
            headers,
            libraryName: library.details.name,
            title: "Import Library Items",
            fields: [{
                type: "file",
                name: "import",
                label: "Import File"
            }]
        }).then((formData) => {
            formData.import.item(0).text().then(async csv => {
                let rows = parseCSV(csv);

                if (rows[0][0] == "_id") {
                    if (JSON.stringify(rows[0].slice(1)) !== JSON.stringify(headers)) {
                        notifier.danger("Incorrect Import Format");
                        return;
                    }
                } else {
                    if (JSON.stringify(rows[0]) !== JSON.stringify(headers)) {
                        notifier.danger("Incorrect Import Format");
                        return;
                    }
                }

                let promises = [];
                // start with row 1 to skip header row
                for (let row of rows.slice(1)) {
                    // handle blank row
                    if (!row[0]) continue;

                    let doc = {};

                    if (rows[0][0] == "_id") {
                        doc = await db.get(row[0]);
                        row = row.slice(1);
                    }

                    formFields.forEach((field, i) => {
                        if (field.type == "tags") {
                            doc[field.name] =  row[i] ? row[i].split(',').map(s => s.trim()) : [];
                        } else {
                            doc[field.name] = row[i];
                        }
                    });

                    if (rows[0][0] == "_id") {
                        promises.push(db.put(doc));
                    } else {
                        promises.push(library.items.newItem(doc));
                    }
                }

                Promise.all(promises).then(() => {
                    notifier.success("Library Items Imported");
                })
            })
        }).catch(e => {
            if (e != "cancel") {
                console.error(e);
            }
        });
    }


    async function showLibraryMappings() {
        assessment_type_mappings = {};

        addFormModal({
            fields: [
                {
                    name: "question_library",
                    label: "Question Library",
                    required: true,
                    type: "select",
                    choices: {
                        static: $question_libraries.map(ql => {return {label: ql.name, value: ql._id}})
                    }
                }
            ]
        }).then(async (data) => {
            let library = await QuestionLibrary.getStatic(data.question_library);

            let library_tag_info = {};
            for (let tag of $library_tags) {
                library_tag_info[tag.item_id] = {
                    color: `is-${tag.color}`,
                    text: tag.name
                }
            }

            for (let category of library.categories) {
                for (let subcategory of category.subcategories) {
                    for (let control of subcategory.controls) {
                        // answer mappings
                        for (let mapping of control.answer_mappings) {
                            if (mapping.details.map.type == "library_item" && mapping.details.map.library_id == params.id) {
                                let answer_info;
                                if (mapping.details.answer == "text" || control.details.question_type == "free_text") {
                                    answer_info = {
                                        color: "",
                                        label: "Text"
                                    }
                                } else {
                                    answer_info = QuestionTypes[control.details.question_type].buttons[mapping.details.answer];
                                }

                                let mapping_info = {
                                    control: control.details.control_number,
                                    color: answer_info.color,
                                    text: answer_info.label
                                };

                                if (!assessment_type_mappings[mapping.details.map.id]) {
                                    assessment_type_mappings[mapping.details.map.id] = [mapping_info];
                                } else {
                                    assessment_type_mappings[mapping.details.map.id].push(mapping_info);
                                }
                            }
                        }


                        // tag mappings
                        for (let mapping of control.tag_mappings) {
                            if (mapping.details.map.type == "library_item" && mapping.details.map.library_id == params.id) {
                                let tag_info = library_tag_info[mapping.details.tag];

                                let mapping_info = {
                                    control: control.details.control_number,
                                    color: tag_info.color,
                                    text: tag_info.text
                                };

                                if (!assessment_type_mappings[mapping.details.map.id]) {
                                    assessment_type_mappings[mapping.details.map.id] = [mapping_info];
                                } else {
                                    assessment_type_mappings[mapping.details.map.id].push(mapping_info);
                                }
                            }
                        }

                    }
                }
            }
        });
    }

    async function showMappings() {
        let choices = $assessment_types.map((type) => {
            return {
                label: type.name,
                value: type._id,
                production: type.production
            }
        });

        choices = groupBy(choices, (choice) => !!choice.production);

        addFormModal({
            fields: [
                {
                    name: "assessment_type",
                    label: "Assessment Type",
                    dflt: choices[true][0].value,
                    required: true,
                    type: "select",
                    choices: {
                        static: {
                            groups: [
                                {
                                    name: "Production",
                                    options: sortBy(choices[true], ['label'])
                                },
                                {
                                    name: "Draft",
                                    options: sortBy(choices[false], ['label'])
                                }
                            ]
                        }
                    }
                }
            ]
        }).then(async (data) => {
            let assessment_type_data = await AssessmentTypeModel.getAssessmentTypeStatic(data.assessment_type);

            let tags = {};
            for (let tag of assessment_type_data.assessment_type_data.question_tags) {
                tags[tag.tag_id] = tag;
            }

            assessment_type_mappings = {};

            for (let category of Object.values(assessment_type_data.assessment_type_data.categories)) {
                for (let subcategory of Object.values(category.subcategories)) {
                    for (let control of Object.values(subcategory.controls)) {
                        // answer mappings
                        for (let [answer, mappings] of Object.entries(control.recommendation_map)) {
                            for (let mapping of mappings) {
                                if (mapping.type == "library_item" && mapping.id.startsWith(params.id)) {
                                    let mapping_info = {
                                        control: control.control_number,
                                    }

                                    if (control.question_type != 'free_text') {
                                        let answer_info = QuestionTypes[control.question_type].buttons[answer]

                                        mapping_info.color = answer_info.color;
                                        mapping_info.text = answer_info.label;
                                    } else {
                                        mapping_info.color = "";
                                        mapping_info.text = "any"
                                    }


                                    if (!assessment_type_mappings[mapping.id]) {
                                        assessment_type_mappings[mapping.id] = [mapping_info];
                                    } else {
                                        assessment_type_mappings[mapping.id].push(mapping_info);
                                    }
                                }
                            }
                        }

                        // tag mappings
                        for (let [tag, mappings] of Object.entries(control.tag_mapping)) {
                            for (let mapping of mappings) {
                                if (mapping.type == "library_item" && mapping.id.startsWith(params.id)) {
                                    let mapping_info = {
                                        control: control.control_number,
                                        color: `is-${tags[tag].color_class}`,
                                        text: tags[tag].name
                                    }
                                    if (!assessment_type_mappings[mapping.id]) {
                                        assessment_type_mappings[mapping.id] = [mapping_info];
                                    } else {
                                        assessment_type_mappings[mapping.id].push(mapping_info);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }

    $: library = new Library(params.id);
    $: library_store = library.store;

    $: loadLibrary($library_store);
</script>

<Loader loading={!$library_store}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            {library.details.name}
            <a href="#/libraries" class="button is-pulled-right">Close</a>
        </h1>
        <SortableTable {sortFields} tableData={[...$library_store.items]} ORM="true" addedColumns={assessment_type_mappings ? 1 : 0}>
            <div slot="rowActions" let:row={item}>
                <div class="buttons is-centered m-0">
                    <button class="button is-danger" on:click={() => deleteItem(item)}>Delete</button>
                    <button class="button is-link" on:click={() => editItem(item)}>Edit</button>
                </div>
            </div>
            <div slot="filterActions">
                <button class="button is-success" on:click={addItem}>Add Item</button>
            </div>
            <div slot="footerActions">
                <div class="buttons is-pulled-left is-narrow m-0">
                    <a href="#/library/{params.id}/moderation" class="button" class:is-primary={[...$library_store.moderation_queue].length}>Moderation Queue ({[...$library_store.moderation_queue].length})</a>
                    <button class="button is-info" on:click={showLibraryMappings}>Show Library Mappings</button>
                    {#if $isAdmin}
                        <button class="button" on:click={importItems}>Import Items</button>
                        <button class="button" on:click={exportItems}>Export Items</button>
                    {/if}
                </div>
                <div class="buttons is-pulled-right">
                    <button class="button is-success" on:click={addItem}>Add Item</button>
                </div>
            </div>

            <svelte:fragment slot="appendHeaders">
                {#if assessment_type_mappings}
                    <th width="200px">Mapped Controls</th>
                {/if}
            </svelte:fragment>

            <svelte:fragment slot="appendColumns" let:row={item}>
                {#if assessment_type_mappings}
                    <td>
                        <div class="field is-grouped is-grouped-multiline">
                            {#each assessment_type_mappings[item.details._id] || [] as mapping}
                                <div class="control">
                                    <div class="tags has-addons">
                                        <span class="tag">{mapping.control}</span>
                                        <span class="tag is-light {mapping.color}">{mapping.text}</span>
                                    </div>
                                </div>
                            {/each}
                        </div>
                    </td>
                {/if}
            </svelte:fragment>


        </SortableTable>
    </div>
</Loader>